import { BrregSearchResult } from '@dap/memberadmin/types';
import { Enheter } from '@dap/generated-types';

export function mapBrregResult(enheter: Enheter): Array<BrregSearchResult> {
  return (
    enheter._embedded?.enheter?.map((enhet) => ({
      name: enhet.navn,
      organizationNumber: enhet.organisasjonsnummer,
    })) || []
  );
}
